<template>
  <div>
    <div class="flex flex-wrap justify-between items-center mb-4">
      <h5>Email</h5>
      <vs-button  @click="addpopup = true"
        >Add</vs-button
      >
    </div>
    <div class="table-responsive">
      <table class="light_blue_table w-full">
        <tbody>
          <tr v-for="(email, index) in emailAvailability" :key="index">
            <td>
              <div class="flex items-center">
                <span class="material-icons-outlined small_icon">email</span>
                Email
              </div>
            </td>
            <td>{{ email.email }}</td>
            <td>
              <vs-checkbox
                :checked="email.default"
                @change="handlePhonedefault(index)"
                >Mark default</vs-checkbox
              >
            </td>
            <td>
              <vs-dropdown>
                <vs-button
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="handleedit(index)"
                  >
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    :disabled="email.default === 1"
                    @click="remove(index)"
                  >
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <vs-popup
      classContent="popup-example"
      title="Add Email"
      :active.sync="addpopup"
    >
      <form data-vv-scope="add">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required|email'"
              name="email"
              v-model="email"
              class="custom_Input"
              label="Email"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('add.email')" class="text-danger">{{
              errors.first("add.email")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleSaveEmail"
          >Save</vs-button
        >
        <vs-button
          type="border"
          color="danger"
          @click="phoneNumberAddpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Edit Email"
      :active.sync="editpopup"
    >
      <form data-vv-scope="edit">
        <vs-row>
          <vs-col :vs-xs="12" :vs-md="12" :vs-lg="12" class="p-2">
            <vs-input
              v-validate="'required|email'"
              name="email"
              v-model="edit"
              class="custom_Input"
              label="Email"
              icon-pack="feather"
              icon="icon-edit"
              icon-after
              style="width: 100%"
            />
            <span v-show="errors.has('edit.email')" class="text-danger">{{
              errors.first("edit.email")
            }}</span>
          </vs-col>
        </vs-row>
      </form>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
        <vs-button class="mr-2" @click.prevent="handleUpdateEmail"
          >Save</vs-button
        >
        <vs-button type="border" color="danger" @click="editpopup = false"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
import { TeacherUpdate } from '@/api/teacher'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
export default {
  name: 'email',
  props: {
    emailProps: {
      required: true,
      type: Array,
      default: () => []
    },
    havePermission:{
      default: false
    }
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Teachers')
    }
  },
  mixins: [PermissionMiddleware],
  data () {
    return {
      addpopup: false,
      deletepopup: false,
      editpopup: false,
      email: null,
      edit: null,
      editIndex: null,
      deleteindex: false,
      emailAvailability: []
    }
  },
  watch: {
    emailProps: {
      deep: true,
      immediate: true,
      handler () {
        this.emailAvailability = this._.cloneDeep(this.emailProps)
      }
    }
  },
  methods: {
    handlePhonedefault (index) {
      this.emailAvailability = this.emailAvailability.map((item) => {
        item.default = 0
        return item
      })
      this.emailAvailability[index].default = 1
      this.editIndex = index
      this.edit = this.emailAvailability[index].email
      this.handleUpdateEmail()
    },
    handleSaveEmail () {
      this.$validator.validateAll('add').then((result) => {
        if (result) {
          const payload = {
            email: this.email,
            default: 0
          }
          this.emailAvailability.push(payload)
          this.handleEmailsave(payload)
        }
      })
    },
    handleedit (index) {
      this.editpopup = true
      this.edit = this.emailAvailability[index].email
      this.editIndex = index
    },
    handleUpdateEmail () {
      this.$validator.validateAll('edit').then((result) => {
        if (result) {
          this.emailAvailability[this.editIndex].email = this.edit
          this.handleEmailsave()
        }
      })
    },
    handleDelete () {
      this.emailAvailability.splice(this.deleteindex, 1)
      this.handleEmailsave()
    },
    remove (index) {
      this.deletepopup = true
      this.deleteindex = index
    },
    async handleEmailsave () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          updateField: {
            email: this.emailAvailability
          }
        }
        const { data } = await TeacherUpdate(
          payload,
          JSON.parse(localStorage.getItem('userInfo')).id,
          customer_id
        )

        this.addpopup = false
        this.email = null
        this.deletepopup = false
        this.editpopup = false

        this.$emit('setAfterUpdate', data)

        this.showSuccessMessage('Success', 'Updated Successfully', 'success')
      } catch (error) {
        console.log(error)
        this.showSuccessMessage('Error', error.data.message, 'danger')
      }
    }
  }
}
</script>
